import React from 'react';
import { useDeleteSystem } from '../../services/hooks/use-delete-system';
import { useSystemFormOptions } from '../../services/hooks/use-system-form-options';
import { useUpdateSystem } from '../../services/hooks/use-update-system';
import { FormEdit } from '../FormEdit';
export const SystemDetails = ({ system, onClose }) => {
    // Список систем инвалидируется внутри мутаций - обновлять таблицу вручную не нужно.
    const { mutate: updateSystem, isLoading: updatingSystem } = useUpdateSystem(onClose);
    const { mutate: deleteSystem } = useDeleteSystem(onClose);
    const options = useSystemFormOptions();
    return (React.createElement(FormEdit, { updatingSystem: updatingSystem, system: system, options: options, onSubmit: updateSystem, onDelete: deleteSystem }));
};
